import React from 'react';

import styled from 'styled-components';

import { ACTION_CENTER_ROUTE } from 'constants/actionCenter';

import SidebarMenuCategoryHeader from './SidebarMenuCategoryHeader';
import SidebarMenuItem from './SidebarMenuItem';

const Container = styled.div`
  padding-top: 20px;
`;

const SidebarMenuActionCenter = () => {
  return (
    <Container>
      <SidebarMenuCategoryHeader title="ACTIONS" />
      <SidebarMenuItem to={ACTION_CENTER_ROUTE.PATH} label="Action Center" />
    </Container>
  );
};

export default SidebarMenuActionCenter;
